import React from 'react';
import ReportingEventsPage from '../components/ReportingEventsPage';

const ReportingEventsApp = (props) => (
  <ReportingEventsPage {...props} />
);

export default ReportingEventsApp;
